import PropTypes from "prop-types";
import classNames from "classnames";
import {
    hasFlag,
    isImportantContent,
    cleanFlag,
    shouldRemainLowercase,
} from "./utils";
import Badge from "../../stories/Components/Badge";
import { BadgeTypes } from "../../stories/Components/Badge/interface";

/**
 * Displays status and/or flag information
 *
 * @param {Object} props The component properties
 * @returns {JSX.Element} The Label component
 */
const Label = ({
    block = false,
    className,
    flag = "",
    highlighted = false,
    external = false,
    id,
}) => {
    const cleanedFlag = cleanFlag(flag);

    const isHighlighted = highlighted || isImportantContent(cleanedFlag);

    const labelTextClasses = classNames("labelText", {
        external: external,
        lower: shouldRemainLowercase(cleanedFlag),
    });

    let labelText;

    if (hasFlag(cleanedFlag)) {
        labelText = flag;
    } else {
        return null;
    }

    const classes = classNames("label", className, {
        highlighted: isHighlighted,
        flag: hasFlag(flag) && !isHighlighted,
        block: block,
    });

    const hasLiveFlag = cleanedFlag === "live";

    return hasLiveFlag ? (
        <Badge type={BadgeTypes.Live} text={"LIVE"} className={"livebadge"} />
    ) : (
        <div id={id} className={classes} data-testid="label">
            <span className={labelTextClasses} data-testid="label-text">
                {labelText}
            </span>
        </div>
    );
};

Label.propTypes = {
    block: PropTypes.bool,
    className: PropTypes.string,
    external: PropTypes.bool,
    flag: PropTypes.string,
    highlighted: PropTypes.bool,
    id: PropTypes.string,
};

export { Label };
